<template>
    <img
        :src="isWin ? stars : flash"
        class="stars absolute h-[25%] top-[2%] scale-[0.4] w-auto right-0"
        :class="[isWin ? 'stars' : 'flash', isShowAnimate && animation ? 'block' : 'hidden']"
    />
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';
// assets
import stars from '~/pages/casino/ringGame/imgs/stars.webp';
import flash from '~/pages/casino/ringGame/imgs/flash.webp';
const props = defineProps({
    isWin: {
        type: Boolean,
        required: true,
    },
    rotateNum: {
        type: Number,
        required: true,
    },
    animation: {
        type: Boolean,
        required: true,
    },
});
const isShowAnimate = ref(false);

watch(
    () => props.rotateNum,
    () => {
        isShowAnimate.value = true;
        setTimeout(() => {
            isShowAnimate.value = false;
        }, 1500);
    },
);
</script>
<style scoped lang="scss">
.stars {
    animation: starsAnimate 1.5s infinite linear;
}

.flash {
    animation: flashAnimate 1.5s infinite linear;
}

@keyframes starsAnimate {
    0% {
        opacity: 0.4;
        transform: scale(0.4);
    }
    25% {
        opacity: 0.9;
        transform: scale(1);
    }
    30% {
        opacity: 0.2;
    }
    45% {
        opacity: 1;
    }
    60% {
        opacity: 0.2;
    }
    75% {
        opacity: 1;
        transform: scale(1);
    }
    100% {
        opacity: 0.4;
        transform: scale(0.4);
    }
}

@keyframes flashAnimate {
    0% {
        opacity: 0;
        transform: scale(1.1);
    }
    25% {
        opacity: 1;
        transform: scale(1);
    }
    30% {
        opacity: 0.5;
        transform: scale(1.1);
    }
    45% {
        opacity: 1;
        transform: scale(1);
    }
    60% {
        opacity: 0.5;
        transform: scale(1.1);
    }
    75% {
        opacity: 1;
        transform: scale(1);
    }
    100% {
        opacity: 0;
        transform: scale(1.1);
    }
}
</style>
